import {
    Box,
    Divider,
    Tab,
    Tabs,
    useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import PlatformList from '../../data/platforms/platform-list.json';
import PlatformDetailsView from './platform-details-view';
import { useNavigate, useParams } from 'react-router-dom';

const PlatformTab = () => {
    const theme = useTheme();

    let { id } = useParams();

    const [value, setValue] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        let value = 0;

        for(let i = 0; i < PlatformList.en.length; i++){
            if(PlatformList.en[i].file === id){
                value = i;
                break;
            }
        }
        
        setValue(value);
    }, [id]);

    const handleChange = (event, newValue) => {
        navigate(`/platform/${PlatformList.en[newValue].file}`);
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    slotProps={{
                        indicator: {
                            style: {
                                display: 'none'
                            }
                        }
                    }}
                    sx={{
                        pb: {xs: 2, md: 5}
                    }}
                >
                    {
                        PlatformList.en.map((item, index) => {
                            return <Tab 
                                key={index}
                                label={item.name}
                                sx={{
                                    backgroundColor: index === value ? item.theme : 'transparent',
                                    border: `1px solid ${index === value ? item.theme : theme.palette.primary.main}`,
                                    borderRadius: 50,
                                    color: 'white',
                                    mx: {xs: 0, md: 1},
                                    transform: index === value ? 'scale(0.9)' : 'scale(1)',
                                    color: theme.palette.primary.main,
                                    '&.Mui-selected': {
                                        color: 'white'
                                    },
                                    fontWeight: 900,
                                    fontSize: {xs: 14, md: 16}
                                }}
                            />
                        })
                    }
                </Tabs>

                <Divider style={{ width: '100%' }}/>

                <Box
                    sx={{
                        pt: {xs: 3, md: 5},
                        px: {xs: 0, md: 3}
                    }}
                >
                    <PlatformDetailsView file={PlatformList.en[value].file}/>
                </Box>
            </Box>
        </>
    );
}

export default PlatformTab;